import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import $ from 'jquery';
import 'jquery-confirm';
import Spinner from '../Spinner';
import api from '../../api/axiosInstance';


const JobCategories = () => {
    const [jobCategories, setJobCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [jobCategoryName, setJobCategoryName] = useState('');
    const [description, setDescription] = useState('');
    const [editingCategoryId, setEditingCategoryId] = useState(null);
      const [blocked, setBlocked] = useState(false);



    const fetchJobCategories = async () => {
        try {
            const response = await api.get('/Administration/ViewJobCategories');
            setJobCategories(response.data);
        } catch (error) {
            console.error("Error fetching categories:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchJobCategories();
    }, []);

 useEffect(() => {
     let table;
     if (!loading) {
         // Initialize DataTables
         table = window.$('#example1').DataTable({
             responsive: true,
             autoWidth: false,                           
             searching: true,
             ordering: true,                                                                                                                                 
             pageLength: 10,
             lengthChange: false, // Fixed typo: was 'lenghtChange'
             paging: true,
             info: true,
             destroy: true, // 💡 Important: allows re-initialization
         });                                                                                                                                                                                                                                   
     }                                                                                                                                                                                                                                                    
 
     // 💡 CLEANUP: This prevents the "e.push" error by destroying 
     // the table instance when the component updates or unmounts.                                                                                                                                                                                                                                                                                                                                                                                                                               
     return () => {
         if (table) {
             table.destroy();
         }
     };
 }, [loading]); 
    const addCategory = async () => {
        if (!jobCategoryName || !description) {
            $.alert({
                title:"",
                content:"Please fill in all fields.",
                type:"red"
            })
            return;
        }

        try {
            setBlocked(true);
            await api.post('/Administration/AddJobCategory', {
                Name: jobCategoryName,
                Description: description
            });
            fetchJobCategories();
            resetForm();
            setBlocked(false);
            showAlert('Success', 'Record saved successfully', 'green');
            const modal = document.getElementById('modal-default');
            modal.style.display = 'none'; // hide the modal
        } catch (error) {
            console.error("Error adding Job category:", error);
            alert("There was an error creating the Job category.");
        }
    };

    const openEditModal = (category) => {
        setEditingCategoryId(category.id);
        setJobCategoryName(category.name);
        setDescription(category.description);
        const modal = document.getElementById('modal-default');
        modal.style.display = 'block'; // Show the modal
    };

    const updateCategory = async () => {
        if (!editingCategoryId || !jobCategoryName || !description) {
           $.alert({
                title:"",
                content:"Please fill in all fields.",
                type:"red"
            })
            return;
        }

        try {
            await api.put(`/Administration/UpdateJobCategory`, {
                Id: editingCategoryId,
                Name: jobCategoryName,
                Description: description
            });
            fetchJobCategories();
            resetForm();
            const modal = document.getElementById('modal-default');
            modal.style.display = 'none'; // Hide the modal
            const backdrop = document.querySelector('.modal-backdrop');

            showAlert('Success', 'Record updated successfully', 'green');
            if (backdrop) {
                backdrop.remove();
            }
        } catch (error) {
            console.error("Error updating Job category:", error);
            alert("There was an error updating the Job category.");
        }
    };

    const resetForm = () => {
        setJobCategoryName('');
        setDescription('');
        setEditingCategoryId(null);
    };

    const showAlert = (title, content, type) => {
        $.confirm({
            title: title,
            content: content,
            type: type,
        });
    };
    const deleteCategory = (categoryId) => {
        $.confirm({
            title: 'Confirm Deletion',
            content: 'Do you really want to delete this?',
            buttons: {
                cancel: {
                    text: 'Cancel',
                    btnClass: 'btn-red',
                    action: function () {
                        // Do nothing on cancel
                    }
                },
                confirm: {
                    text: 'Yes, delete it!',
                    btnClass: 'btn-green',
                    action: async function () {
                        try {
                            setBlocked(true);
                            const response = await api.delete(`/Administration/DeleteJobCategory/${categoryId}`);                           

                            // Success alert
                            $.alert({
                                title: 'Success!',
                                content: response.data,
                                type: 'green',
                                buttons: {
                                    okay: {
                                        text: 'Ok',
                                        btnClass: 'btn-green',
                                        action: function () {
                                            // Refresh the category data after deletion
                                            api.get(`/Administration/ViewJobCategories`)
                                                .then(fetchResponse => {
                                                    setJobCategories(fetchResponse.data);
                                                });
                                                setBlocked(false);
                                        }
                                    }
                                }
                            });
                        } catch (error) {
                             setBlocked(false);
                            if (error.response && error.response.status === 409) {
                                $.alert({
                                    title: 'Error!',
                                    content: error.response.data,
                                    type: 'red',
                                });
                            } else {
                                $.alert({
                                    title: 'Error!',
                                    content: 'Error deleting Jobcategory',
                                    type: 'red',
                                });
                            }
                        }
                    }
                }
            }
        });
    };

  const backdropStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  background: "rgba(0,0,0,0.2)", // light dark shade
  zIndex: 9998,
  cursor: "wait"  // cursor changes to loading
};

const overlayStyle = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  background: "#222",
  padding: "30px 50px",
  borderRadius: "12px",
  zIndex: 9999,
  color: "#fff",
  fontSize: "22px",
  textAlign: "center",
  cursor: "wait" // cursor loading
};  


    return (
  
    <>
                    {blocked && (
  <>
    {/* FULL SCREEN BACKDROP THAT BLOCKS CLICKS */}
    <div style={backdropStyle}></div>

    {/* CENTER BOX */}
    <div style={overlayStyle}>
      <div className="spinner-border" role="status"></div>
      <div>Please wait…</div>
    </div>
  </>
)}
    
            <Helmet>
                <title>Job Categories</title>
            </Helmet>
            <div>
                <div className="card card-success" style={{ marginTop: '0px' }}>
                    <div className="card-header" style={{ display: 'flex', flexDirection: 'column' }}>
                        <h3 className="card-title">Job Categories</h3>
                        {/* <div style={{ marginTop: '10px' }}>
                            <button
                                className='btn btn-success btn-default'
                                title='Add Category'
                                onClick={() => {
                                    resetForm();
                                    const modal = document.getElementById('modal-default');
                                    modal.style.display = 'block'; // Open modal for adding
                                }}
                            >
                                <i className='fa fa-write'></i> New
                            </button>
                        </div> */}
                    </div>
                    <div className="card-body">

                        <div className="row">
                            <div className="col-sm-3">
                                <div style={{ marginBottom: '10px' }}>
                                    <div style={{ marginTop: '0px' }}>
                                        <button
                                            className='btn btn-success btn-sm'
                                            title='Add Category'
                                            onClick={() => {
                                                resetForm();
                                                const modal = document.getElementById('modal-default');
                                                modal.style.display = 'block'; // Open modal for adding
                                            }}
                                        >
                                            <i className='fa fa-write'></i> New
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>

                        {loading ? (
                            <Spinner /> // Use the Spinner component here
                        ) : (
                            <div className="col-sm-12">
                                <table id="example1" className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th width="42%">Name</th>
                                            <th width="37%">Description</th>
                                            <th width="13%">Created On</th>
                                            <th width="8%">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {jobCategories.map(category => (
                                            <tr key={category.id}>
                                                <td>{category.name}</td>
                                                <td>{category.description}</td>
                                                <td>{new Date(category.createdOn).toLocaleDateString()}</td>
                                                <td>
                                                    <button
                                                        className='btn btn-xs btn-success'
                                                        onClick={() => openEditModal(category)}
                                                        title='Edit'
                                                        data-toggle="modal"
                                                        data-target="#modal-default"
                                                    >
                                                        <i className='fa fa-edit'></i>
                                                    </button>
                                                    &nbsp;&nbsp;&nbsp;
                                                    <button
                                                        className='btn btn-xs btn-danger'
                                                        title='Delete'
                                                        onClick={() => deleteCategory(category.id)}
                                                    >
                                                        <i className='fa fa-trash'></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th>Name</th>
                                            <th>Description</th>
                                            <th>Created On</th>
                                            <th>Action</th>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>

                        )}
                    </div>
                </div>
            </div >
            <div className="modal" id="modal-default" style={{ display: 'none' }}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">{editingCategoryId ? 'Edit Category' : 'Add New Category'}</h4>
                            <button type="button" className="close" onClick={() => {
                                const modal = document.getElementById('modal-default');
                                modal.style.display = 'none'; // Hide the modal
                                const backdrop = document.querySelector('.modal-backdrop');
                                if (backdrop) {
                                    backdrop.remove();
                                }
                            }}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className="form-group">
                                        <label htmlFor="name">Job Category Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="name"
                                            maxLength={100}
                                            value={jobCategoryName}
                                            onChange={(e) => setJobCategoryName(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className="form-group">
                                        <label htmlFor="description">Description</label>
                                        <textarea
                                            className="form-control"
                                            id="description"
                                            rows={4}
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer justify-content-between">
                            <button type="button" className="btn btn-default" onClick={() => {
                                const modal = document.getElementById('modal-default');
                                modal.style.display = 'none'; // Hide the modal
                                const backdrop = document.querySelector('.modal-backdrop');
                                if (backdrop) {
                                    backdrop.remove();
                                }
                            }}>Close</button>
                            <button type="button" className="btn btn-primary" onClick={editingCategoryId ? updateCategory : addCategory}>
                                {editingCategoryId ? 'Save Changes' : 'Add Category'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </>
   
    );
};

export default JobCategories;
